import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
  UserPoolId: "eu-west-2_SGSN2SGn0",
  ClientId: "279pkmfhmijrs69nfjrlhvsv1k",
};

export default new CognitoUserPool(poolData);
